import getCentralKitchenProductionPlanningSettings from './getCentralKitchenProductionPlanningSettings';
import getCentralKitchenSettingsCardSettings from './getCentralKitchenSettingsCardSettings';
import getStoreCompanySettings from './getStoreCompanySettings';
import getStoreDuplicationSettingsCardSettings from './getStoreDuplicationSettingsCardSettings';
import getStoreGPSCoordinatesCardSettings from './getStoreGPSCoordinatesCardSettings';
import getStoreInformationCardSettings from './getStoreInformationCardSettings';
import getStoreInvoiceControlSettings from './getStoreInvoiceControlSettings';
import getStoreLocationCardSettings from './getStoreLocationCardSettings';
import getStoreProductionCardSettings from './getStoreProductionCardSettings';
import getStoreProductMixCardSettings from './getStoreProductMixCardSettings';
import getStoreSettingsCardSettings from './getStoreSettingsCardSettings';
import lockMosOwnedInputs from './lockMosOwnedInputs';

export { STORE_DUPLICATION_TYPE, CLONE_STORE_STEP } from './getStoreSettingsCardSettings';

export default {
  getStoreInformationCardSettings,
  getStoreGPSCoordinatesCardSettings,
  getStoreLocationCardSettings,
  getStoreProductionCardSettings,
  getStoreProductMixCardSettings,
  getStoreSettingsCardSettings,
  getStoreDuplicationSettingsCardSettings,
  getCentralKitchenProductionPlanningSettings,
  getCentralKitchenSettingsCardSettings,
  getStoreCompanySettings,
  getStoreInvoiceControlSettings,
  lockMosOwnedInputs,
};
